import Vue from 'vue'
import Router from 'vue-router';
import Login from '../pages/login/index.vue';
import Contact from '../pages/chat/index.vue';
import Manage from '../pages/manage.vue'
import planList from '../pages/planList.vue';
import dhzplanList from '../pages/dhzplanList.vue';
import kong from '../pages/kong.vue';

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            redirect: '/login'
        },
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'login',
            component: Login
        },
        {
            path: '/manage',
            component: Manage,
            name: 'manage',
            meta: {
                requiresAuth: false,
            },
            children: [
                
                {
                    path: '/kong',
                    name: 'kong',
                    component: kong
                },
                {
                    path: '/dhzplanList',
                    name: 'dhzplanList',
                    component: dhzplanList
                },
                {
                    path: '/planList',
                    name: 'planList',
                    component: planList
                },
                {
                    path: '/contact/:id',
                    name: 'contact',
                    component: Contact
                },
                {
                    path: '/contact',
                    name: 'contact',
                    component: Contact
                },
                {
                    path: '/group/:id',
                    name: 'group',
                    component: Contact
                },
                {
                    path: '/group',
                    name: 'group',
                    component: Contact
                },
                {
                    path: '/chatroom/:id',
                    name: 'chatroom',
                    component: Contact
                },
                {
                    path: '/chatroom',
                    name: 'chatroom',
                    component: Contact
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js